import React from "react";
import { DIFFICULTY_META } from "@/lib/exerciseLabels";
import { cn } from "@/lib/utils";

export function DifficultyPills({ value, onChange, stats, lang }) {
  const L = lang === "id" ? "id" : "en";
  const locale = L === "id" ? "id-ID" : "en-US";
  const pills = [["all", { id: "Semua tingkat", en: "All levels" }, stats?.total], ...Object.entries(DIFFICULTY_META).map(([k, m]) => [k, m, stats?.difficulties?.[k]])];
  return (
    <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1 no-scrollbar" data-testid="difficulty-pills">
      {pills.map(([k, m, n]) => {
        const active = value === k;
        return (
          <button key={k} type="button" onClick={() => onChange(k)} data-testid={`difficulty-pill-${k}`} aria-pressed={active}
            className={cn("inline-flex shrink-0 items-center gap-2 rounded-full border px-4 py-1.5 text-sm font-semibold transition-colors",
              active ? (m.on || "border-foreground bg-foreground text-background") : "bg-card text-muted-foreground hover:text-foreground")}>
            {m.dot && <span className={cn("h-2 w-2 rounded-full", active ? "bg-white" : m.dot)} />}
            {m[L]}
            {n != null && <span className="text-xs font-medium tabular-nums opacity-70">{n.toLocaleString(locale)}</span>}
          </button>
        );
      })}
    </div>
  );
}

export function DifficultyText({ level, lang, className }) {
  const m = DIFFICULTY_META[level];
  if (!m) return null;
  return (
    <span className={cn("inline-flex items-center gap-1 font-medium", m.text, className)} data-testid="difficulty-label">
      <span className={cn("h-1.5 w-1.5 rounded-full", m.dot)} />{m[lang === "id" ? "id" : "en"]}
    </span>
  );
}
